module.exports = __webpack_public_path__ + "img/mind_skeleton_101.71fac860.png";